var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-row" }, [
    _c("div", { staticClass: "form-group col-md-4" }, [
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.alarmTag,
              expression: "alarmTag"
            }
          ],
          staticClass: "form-check-input",
          attrs: { id: _vm.uid + "_alarmtag", type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.alarmTag)
              ? _vm._i(_vm.alarmTag, null) > -1
              : _vm.alarmTag
          },
          on: {
            change: function($event) {
              var $$a = _vm.alarmTag,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.alarmTag = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.alarmTag = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.alarmTag = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: _vm.uid + "_alarmtag" }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "workflow.vueFormBuilder.elements.date.model.alarmEnabled"
                  )
                ) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group col-md-4" }, [
      _c("div", { staticClass: "form-check" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.valueFormat,
              expression: "valueFormat"
            }
          ],
          staticClass: "form-check-input",
          attrs: { id: _vm.uid + "_valueFormat", type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.valueFormat)
              ? _vm._i(_vm.valueFormat, null) > -1
              : _vm.valueFormat
          },
          on: {
            change: function($event) {
              var $$a = _vm.valueFormat,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.valueFormat = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.valueFormat = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.valueFormat = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-check-label",
            attrs: { for: _vm.uid + "_valueFormat" }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "workflow.vueFormBuilder.elements.date.model.storeAsUnixTimestamp"
                  )
                ) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }